// member-portal/src/components/Banner.js — FIXED: Added proper navigation for "Become a Promoter"

import React, { useState, useEffect, useRef, useCallback } from 'react';
import './Banner.css';
import logo from '../logo.png';

// Define rotating texts outside the component to prevent recreation
const rotatingTexts = ['New Customers', 'A better way to advertise', 'How to reach more customers', 'Get your deals out there', 'Increase sales'];

const Banner = ({ user, setView, handleLogout, navigateTo, isLanding }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [textIndex, setTextIndex] = useState(0);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setTextIndex((prev) => (prev + 1) % rotatingTexts.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const handleClickOutside = useCallback((event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsMenuOpen(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [handleClickOutside]);

  const normalizedUser = user || {};
  const isAuthenticated = user && user.token;

  const handlePricingClick = () => {
    window.open('https://scover.co.za/pricing', '_blank');
  };

  const handleHowItWorksClick = () => {
    window.open('https://scover.co.za/how-it-works', '_blank');
  };

  const handlePromoterClick = () => {
    console.log('[Banner] "Become a Promoter" clicked — navigating to promoter-signup');
    navigateTo('promoter-signup');
  };

  const handleContactUsClick = () => {
    window.location.href = 'mailto:support@scover.co.za';
    setIsMenuOpen(false);
  };

  return (
    <div className="banner">
      <div className="header-content">
        <div className="static-container">
          <img src={logo} alt="Scover Logo" className="banner-logo" />
        </div>
        <div className="rotating-container">
          <span className="rotating-text">{rotatingTexts[textIndex]}</span>
        </div>
      </div>
      <div className="banner-right">
        {!isLanding && isAuthenticated && (
          <div className="user-info">
            <span className="welcome-text">Welcome, {normalizedUser.name || 'User'}</span>
          </div>
        )}
        {isLanding && (
          <div className="pricing-info">
            <button className="banner-button" onClick={handlePricingClick}>
              Pricing
            </button>
            <button className="banner-button" onClick={handleHowItWorksClick}>
              How It Works
            </button>

            {/* ─────────────────────────────────────────────────────────────
                 NEW: Become a Promoter link — visible only on landing page
                 Fixed navigation handler
                 ───────────────────────────────────────────────────────────── */}
            <button className="banner-button promoter-link" onClick={handlePromoterClick}>
              Become a Promoter
            </button>
            {/* ───────────────────────────────────────────────────────────── */}
          </div>
        )}
        {!isLanding && isAuthenticated && (
          <div className="hamburger-menu" ref={dropdownRef}>
            <button className="hamburger-button" onClick={() => setIsMenuOpen(!isMenuOpen)}>
              ☰
            </button>
            {isMenuOpen && (
              <div className="hamburger-dropdown">
                <button onClick={handleContactUsClick}>Contact Us</button>
                <button onClick={() => { handleLogout(); setIsMenuOpen(false); }}>Logout</button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(Banner);